export default class DirectionsService {
  constructor() {
    this.googleMapsBaseUrl = 'https://maps.google.com/?q=';
    this.appleMapsBaseUrl = 'https://maps.apple.com/?q='
  }

  openDirections(address) {
    if (this.isIos()) {
      window.open(`${this.appleMapsBaseUrl}${address}`);
    } else {
      window.open(`${this.googleMapsBaseUrl}${address}`);
    }
  }

  isIos() {
    return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.platform)
      || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
}
